module.exports = __webpack_public_path__ + "images/Deterring Adversarial Behavior at Scale in Gitcoin Grants.pdf?v=6999b94389de4af2f4f642a91cd3d895";